<template>
  <!-- 运单管理 -->
  <div class="page-container">
    <div v-if="isAdjust" class="main_page">
      <div class="page_title">
        <div class="page_title_desc">运单管理</div>
        <kt-button
          icon=""
          label="下载中心"
          perms="-1"
          type="text"
          size="medium"
          class="whiteList_box_title_cz"
          @click="getAdjust"
        />
      </div>
      <el-divider></el-divider>
      <!--搜索栏-->
      <div class="toolbar">
        <el-form :inline="true" :model="filterForm" :size="size">
          <el-form-item label>
            <el-input
              clearable
              v-model="filterForm.bookingNo"
              placeholder="请输入预约id"
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input
              clearable
              v-model="filterForm.waybillNo"
              placeholder="请输入运单编号"
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input
              clearable
              v-model="filterForm.coalMineName"
              placeholder="请输入煤矿名称"
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input
              clearable
              v-model="filterForm.purchaseName"
              placeholder="请输入采购方名称"
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <el-input
              clearable
              v-model="filterForm.coalCategoryName"
              placeholder="请输入煤种"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              clearable
              v-model="filterForm.carLicensePlateNo"
              placeholder="请输入车牌号"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              clearable
              v-model="filterForm.driverName"
              placeholder="请输入司机姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="filterForm.mjpType"
              placeholder="请选择煤检票类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in mjpTypeList"
                :key="item.id"
                :label="item.title"
                :value="item.title"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="filterForm.status"
              placeholder="请选择状态"
              clearable
              filterable
            >
              <el-option
                v-for="item in statusList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.signupTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="申请时间开始时间"
              end-placeholder="申请时间结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.outStationTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="到站过皮开始时间"
              end-placeholder="到站过皮结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.enterStationTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="到站过毛开始时间"
              end-placeholder="到站过毛结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filterForm.dispatchType" clearable filterable placeholder="派单类型">
              <el-option v-for="item in  pollingTypeList" :key="item.code" :value="item.code" :label="item.name" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-search"
              label="搜索"
              perms="-1"
              type="primary"
              @click="handleSearch"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-share"
              label="重置"
              perms="-1"
              @click="handleReset"
              type="primary"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-sign-out"
              label="导出"
              perms="30600"
              type="primary"
              @click="handleExport"
            />
          </el-form-item>
        </el-form>
      </div>
      <!--运单表格-->
      <el-table :data="waybillList" stripe size="mini" style="width: 100%">
        
        <el-table-column
          prop="waybillNo"
          align="center"
          width="240"
          label="运单编号"
        >
          <template slot-scope="scope">
            <span
              class="waybillbo-style"
                @click="handleToDetail(scope.row)"
                >{{scope.row.waybillNo}}</span
              >
              <p>{{scope.row.bookingNo}}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="240" label="司车信息">
          <template slot-scope="scope">
            <p>{{scope.row.carLicensePlateNo}}</p>
            <p>{{scope.row.driverName}}</p>
            <p>{{scope.row.driverPhone}}</p>
          </template>
        </el-table-column>
        
        <!-- <el-table-column
          prop="enterParkWayDesc"
          align="center"
          width="100"
          label="入场方式"
        ></el-table-column> -->
        <!-- <el-table-column align="center" width="100" label="超时入场">
          <template slot-scope="scope">
            {{ scope.row.timeoutEnterPark == 0 ? "否" : "是" }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column align="center" width="100" label="是否矫正">
          <template slot-scope="scope">
            {{ scope.row.arriveStationAdjustWeightFlag == 0 ? "否" : "是" }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column align="center" width="80" label="矫正历史">
          <template slot-scope="scope">
            <el-popover placement="right" width="400" trigger="click">
              <el-timeline v-if="historyAxis.length > 0">
                <el-timeline-item
                  v-for="(item, index) in historyAxis"
                  :key="index"
                  :color="item.color"
                  :timestamp="item.timestamp"
                >
                  <p class="historyItem-title">矫正前：</p>
                  <p
                    class="historyItem"
                    v-for="n in item.modifyBefore"
                    :key="n.name"
                  >
                    {{ n.desc }}：{{ n.value }}吨
                  </p>
                  <p class="historyItem-title">矫正后：</p>
                  <p
                    class="historyItem"
                    v-for="(n, i) in item.modifyAfter"
                    :key="i"
                  >
                    {{ n.desc }}：{{ n.value }}吨
                  </p>
                </el-timeline-item>
              </el-timeline>
              <div v-else>暂无数据</div>
              <el-button
                type="text"
                slot="reference"
                size="mini"
                @click="handleGetAdjustHistory(scope.row)"
                >查看</el-button
              >
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="装卸地点">
          <template slot-scope="scope">
            <p>装：{{scope.row.coalMineName}}</p>
            <p>卸：{{scope.row.unloadingAddress}}</p>
            <el-button type="text" size="mini" @click="toTrailDetail(scope.row)"
              >查看轨迹</el-button
            >
          </template>
        </el-table-column>
        <el-table-column align="center" width="180" label="运单时间轴" >
          <template slot-scope="scope">
            <el-popover placement="right" width="400" trigger="click">
              <el-timeline v-if="timeAxis.length > 0">
                <el-timeline-item
                  v-for="(item, index) in timeAxis"
                  :key="index"
                  :color="item.color"
                  :timestamp="item.timestamp"
                >
                  {{ item.content }}
                </el-timeline-item>
              </el-timeline>
              <div v-else>暂无数据</div>
              <el-button
                type="text"
                slot="reference"
                size="mini"
                @click="handleGetTimeAxis(scope.row)"
                >查看时间轴</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="statusDesc"
          width="180"
          label="运单状态"
        ></el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float: right"
        ></el-pagination>
      </div>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
        <span class="class_center">请确认是否导出？</span>
        <br />
        <span class="class_center">导出的数据请在下载中心内进行下载</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="handleClose"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <el-dialog
      :visible.sync="showTrailDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="查看轨迹"
      width="80%"
    >
      <div class="trail-content">
        <div id="map_container"></div>
        <div class="trail-list">
          <div class="trail-title">运单{{ currentRow.waybillNo }}历史轨迹</div>
          <div class="trail-container">
            <span class="title">状态变更时间轴:</span>
            <div
              v-for="(item) in computedStatusList"
              :key="item.index"
              
            >
              <div class="list-item">
                <span style="display: flex; align-items: center; cursor:pointer" @click="showWayBillDetail(item)"
                >
                <svg t="1630057704067" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1508" width="16" height="16"><path d="M511.5 512c-72.8 0-130-57.2-130-130s57.2-130 130-130 130 57.2 130 130-57.2 130-130 130z m0.5-448c-174.7 0-313.5 138.9-313.5 313.6C198.5 610.6 512 960 512 960s313.5-349.4 313.5-582.4C825.5 202.9 686.7 64 512 64z" :fill="judgeColor(item)" p-id="1509"></path></svg>
                {{ item.content }}:</span
              >
              <p>{{ item.timestamp }}</p>
              </div>
              <span v-if="item.locStatus" style="color:red;font-size:12px">（坐标点上传异常）</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <DownloadCenter v-if="!isAdjust" @Adjust="AdjustFun" />
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import DownloadCenter from "./DownloadCenter.vue";
import BaiduMap from "@/utils/baidu-map.js";
let map = null;
// const colorList = [
//   "#1afa29",
//   "#1afa29",
//   "#1afa29",
//   "#f4ea2a",
//   "#1296db",
//   "#1296db",
//   "#1296db",
//   "#1296db",
//   "#13227a",
//   "#d81e06",
//   "#d81e06",
// ];
// 一些svg图标  
import {greenMarker,
  redMarker,
  yellowMarker,
  blueMarker,
  deepblueMarker,
  blackMarker} from '@/utils/instance.js'
const trailArray = [];  //绘制的路径 
//公共的标注配置
const opts = {
  width:100,
  height :50,
  title:'运单详情',
  offset:{width:0,height:-16}
}

export default {
  components: {
    KtButton,
    DownloadCenter,
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      waybillList: [],
      statusList: [],
      mjpTypeList: [],
      filterForm: {
        waybillNo: "",
        coalMineName: "",
        purchaseName: "",
        coalCategoryName: "",
        driverName: "",
        status: "",
        dispatchType:''
      },
      pollingTypeList:[],
      // colorList,
      showTrailDialog: false,
      timeAxis: [],
      historyAxis: [],
      isAdjust: true,
      dialogVisible: false,
      trailDetail: [],
      waybillStatusList: [],
      currentRow: {},
      trailRoute: {},
      statusInfoWindow:{}
    };
  },
  computed: {
    computedSignType() {
      return (row) => {
        switch (row.signUpStatus) {
          case 0:
            return "已缴费";
          case 1:
            return "已退款";
          case 2:
            return "交易中,报名缴费";
          case 3:
            return "交易中,退款缴费";
          case 4:
            return "无需缴费";
          case 5:
            return "交易失败";
          default:
            return "其他";
        }
      };
    },
    computedStatusList() {
      let arr = this.waybillStatusList.reverse();
      arr.forEach((item) => {
        return (item.content = item.statusDesc.slice(0, 3));
      });
      return arr;
    },
    // computedImage() {
    //   return (i) => {
    //     return this.imageList[i].src;
    //   };
    // },
    judgeColor(){
      return (item) => {
        switch(item.statusDesc){
          case '待支付':
          case '已匹配':
          case '已申请':
            return "#1afa29"
          case '已派单':
            return "#f4ea2a"
          case '已入场':
          case '已出场':
          case '已入矿':
            return '#1296db'
          case '已出矿':
            return '#d81e06'
          case '已出站':
          case '已入站':
            return '#13227a'
          case '已取消':
          case '已驳回':
            return '#000'
          
        }
      }
    }
  },
  mounted() {
    this.getAllStatusList();
    this.getWaybillList();
    this.getPollingType()
    this.ticketStatusList();
  },
  methods: {
    getPollingType(){
      this.$api.waybill.getPollingType({
      }).then((res) => {
        this.pollingTypeList = res.data
      })
    },
    // 获取所有状态列表
    async getAllStatusList() {
      let res = await this.$api.waybill.mGetAllStatusList();
      if (res.data && res.data.length > 0) {
        this.statusList = res.data.filter((item) => {
          return item.code != 16;
        });
      } else {
        this.statusList = [];
      }
    },
    showWayBillDetail(item){
      this.statusInfoWindow =new BMap.InfoWindow(`<p style="margin:0">${item.timestamp}</p><span>${item.statusDesc}</span>`,opts)
      map.openInfoWindow(this.statusInfoWindow,new BMap.Point(item.lng, item.lat))
    },
    //查看运单轨迹

    toTrailDetail(row) {
      //根据运单调轨迹接口
      
      this.currentRow = row;
      this.getDriverLocationLog(row)
    },
    //根据单号请求状态和时间
    async getWayBillDetail(waybillNo) {
      let res = await this.$api.waybill.getTimeAxis({
        waybillNo,
      });
      //这里用的时间轴的接口 需要处理掉备注和 个别状态 已取消已驳回 
      this.waybillStatusList = res.data;
    },
    async getDriverLocationLog(row){
      let res =await this.$api.waybill.getDriverLocationLog({
        waybillNo:row.waybillNo
      })
      if(res.data){
        this.trailDetail =  res.data.locationLogList
      this.waybillStatusList = res.data.timeAxisMapList
      this.showTrailDialog = true;
      this.mapInit()
      }else{
        this.$message({
          type:'error',
          message:'当前运单并无轨迹',
          offset :300
        })
      }
    },
    async mapInit() {
      await BaiduMap.initVersion2();
      map = new BMap.Map("map_container", {
        enableMapClick: false,
      });

      map.enableScrollWheelZoom();
      let top_left_control = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
      }); // 左上角，添加比例尺
      let top_left_navigation = new BMap.NavigationControl({
        type: "BMAP_NAVIGATION_CONTROL_LARGE",
      }); //左上角，添加默认缩放平移控件
      trailArray.length = 0
      this.trailDetail.map((item) => {
        trailArray.push(new BMap.Point(item.lng, item.lat));
        let marker = new BMap.Marker(new BMap.Point(item.lng, item.lat),{
          icon: this.judgeIcon(item)
        })
        let infoWindow = new BMap.InfoWindow(`<p style="margin:0">${item.createTime}</p><span>${item.statusDesc}</span>`,opts)
        marker.addEventListener('click',() => {
          map.openInfoWindow(infoWindow,new BMap.Point(item.lng, item.lat))
        })
        map.addOverlay(marker)
      });
      this.trailRoute = new BMap.Polyline(trailArray, {
        strokeColor: "#0066FF", //边线颜色。
        fillColor: "#fff", //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: 4, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.3, //填充的透明度，取值范围0 - 1。
        strokeStyle: "solid", //边线的样式，solid或dashed。
        enableEditing: false,
      });
      map.centerAndZoom(new BMap.Point(this.trailDetail[0].lng,this.trailDetail[0].lat),20);
      map.addOverlay(this.trailRoute);
      map.addControl(top_left_control);
      map.addControl(top_left_navigation);
      
    },

    judgeIcon(item){
      //两种情况 异常与非异常 
      //[{"code":1,"name":"待支付"},{"code":11,"name":"已申请"},{"code":2,"name":"已匹配"},{"code":15,"name":"已派单"},{"code":3,"name":"已入场"},{"code":4,"name":"已出场"},{"code":5,"name":"已入矿"},{"code":6,"name":"已出矿"},{"code":13,"name":"已入站"},{"code":16,"name":"已领单"},{"code":14,"name":"已出站"},{"code":7,"name":"已取消"},{"code":8,"name":"已驳回"}]
      // if(item.locStatus){
        switch(item.status){
          case 1 : 
          case 2 : 
          case 11 : return greenMarker
          case 15 : return yellowMarker
          case 3 : 
          case 4 : 
          case 5 : return blueMarker
          case 6 : return redMarker
          case 13:
          case 14 : return deepblueMarker
          case 7:
          case 8:
           return blackMarker
        }
      // }else{
        // return blackMarker
      // }
      
    },
    //获取所有煤检票类型
    async ticketStatusList() {
      let res = await this.$api.waybill.mGetAllTicketType();
      this.mjpTypeList = res.data;
    },
    // 获取运单列表
    async getWaybillList() {
      const _t = this;
      _t.waybillList = [];
      const params = {
        pageNo: _t.pageNo,
        pageSize: _t.pageSize,
      };
      const form = { ..._t.filterForm };
      let index = 0;
      for (let key in form) {
        const val = form[key];
        if (val === 0 ||(val !== ""&&val)) {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (
            key === "signupTime" ||
            key === "enterStationTime" ||
            key === "outStationTime"
          ) {
            params[
              "searchFieldList[" + index + "].rangeMinValue"
            ] = `${val[0]} 00:00:00`;
            params[
              "searchFieldList[" + index + "].rangeMaxValue"
            ] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.waybill.mGetWaybillList(params);
      _t.totalSize = res.data.totalSize;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        _t.waybillList = res.data.dtoList;
      } else {
        _t.waybillList = [];
      }
    },

    // 隐藏或者显示下载中心
    getAdjust() {
      this.isAdjust = false;
    },

    AdjustFun(val) {
      this.isAdjust = val;
    },
    // 获取时间轴
    async handleGetTimeAxis(row) {
      let res = await this.$api.waybill.getTimeAxis({
        waybillNo: row.waybillNo,
      });

      if (res.data.length > 0) {
        res.data[0]["color"] = "#0bbd87";
      }
      this.timeAxis = res.data;
    },

    // 获取矫正历史
    async handleGetAdjustHistory(row) {
      let res = await this.$api.waybill.getAdjustHistory({
        pageNo: 1,
        pageSize: 1000,
        dataPk: row.waybillNo,
        operationModule: 6,
        operationType: 16,
      });

      const historyAxis = [];
      if (res.data && res.data.dtoList) {
        res.data.dtoList.forEach((n) => {
          historyAxis.push({
            timestamp: n.operationTime,
            modifyBefore: JSON.parse(n.modifyBeforeJson),
            modifyAfter: JSON.parse(n.modifyAfterJson),
          });
        });
      }
      if (historyAxis.length > 0) {
        historyAxis[0]["color"] = "#0bbd87";
      }
      this.historyAxis = historyAxis;
    },

    // 换页刷新和搜索
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getWaybillList();
    },

    handleToDetail(row){
      window.open(location.origin+'/waybill/detail?id='+row.waybillNo)
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getWaybillList();
    },

    // 重置
    handleReset() {
      this.filterForm = {};
      this.handleSearch();
    },
    // 确认导出
    handleClose() {
      const _t = this;
      const params = {
        pageNo: 1,
        pageSize: 5000,
      };
      const form = { ..._t.filterForm };
      let index = 0;
      for (let key in form) {
        const val = form[key];
        if (val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (
            key === "signupTime" ||
            key === "enterStationTime" ||
            key === "outStationTime"
          ) {
            params[
              "searchFieldList[" + index + "].rangeMinValue"
            ] = `${val[0]} 00:00:00`;
            params[
              "searchFieldList[" + index + "].rangeMaxValue"
            ] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      _t.$api.waybill.getWaybillExport(params).then((res) => {
        if (res.code === "0") {
          _t.$message({
            message: "成功创建下载任务，请稍后在下载中心内进行下载",
            type: "success",
          });
          _t.dialogVisible = false;
        }
      });
    },
    // 导出
    handleExport() {
      this.dialogVisible = true;
    },
    exportExcel(list) {
      const _t = this;
      list.map((item) => {
        item.mindImageUrl = `${item.mindImageUrl1} ${item.mindImageUrl2}`;
        item.arriveImageUrl = `${item.arriveImageUrl1} ${item.arriveImageUrl2}`;
      });
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../utils/Export2Excel");
        const tHeader = [
          "序号",
          "运单id",
          "预约id",
          "煤矿",
          "采购方",
          "卸货地",
          "煤型",
          "煤型单价（元/吨）",
          "车牌号",
          "司机姓名",
          "手机号",
          "身份证号",
          "煤检票类型",
          "车辆预载值（吨）",
          "矿发皮重",
          "矿发毛重",
          "矿发净重",
          "销售价格",
          "矿发票据单号",
          "矿发票据时间",
          "矿发图片",
          "到站皮重",
          "到站毛重",
          "到站净重",
          "到站票据单号",
          "到站票据时间",
          "到站图片",
          "运费（元/吨）",
          "入场方式",
          "超时入场",
          "是否矫正",
          "申请时间",
          "匹配时间",
          "派单时间",
          "入场时间",
          "出场时间",
          "入矿时间",
          "出矿时间",
          "过毛时间",
          "过皮时间",
          "过磅单号",
          "状态",
        ]; // 设置Excel的表格第一行的标题
        const filterVal = [
          "index",
          "waybillNo",
          "bookingNo",
          "coalMineName",
          "purchaseName",
          "unloadingAddress",
          "coalCategoryName",
          "unitPrice",
          "carLicensePlateNo",
          "driverName",
          "driverPhone",
          "driverIdCard",
          "mjpType",
          "preLoadVal",
          "tareWeight",
          "grossWeight",
          "netWeight",
          "goodsPrice",
          "mindBillNo",
          "mindBillTime",
          "mindImageUrl",
          "arriveStationTareWeight",
          "arriveStationGrossWeight",
          "arriveStationNetWeight",
          "arriveBillNo",
          "arriveBillTime",
          "arriveImageUrl",
          "transportPrice",
          "enterParkWayDesc",
          "timeoutEnterPark",
          "arriveStationAdjustWeightFlag",
          "signupTime",
          "matchTime",
          "dispatchTime",
          "enterParkTime",
          "outParkTime",
          "enterMineTime",
          "outMineTime",
          "enterStationTime",
          "outStationTime",
          "arriveStationPoundNo",
          "statusDesc",
        ]; // index、nickName、name是tableData里对象的属性
        const data = _t.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "运单管理"); //导出Excel 文件名
      });
    },
    // 导出时类型转化
    exportFormat(res) {
      const list = res;
      list.forEach((item, index) => {
        item["index"] = index + 1;
        item["remark"] = item["remark"] || "无";
        item["timeoutEnterPark"] = item["timeoutEnterPark"] == 0 ? "否" : "是";
        item["arriveStationAdjustWeightFlag"] =
          item["arriveStationAdjustWeightFlag"] == 0 ? "否" : "是";
      });
      return list;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}
.historyItem-title {
  color: #333;
}
.historyItem {
  font-size: 13px;
  color: #666;
  padding: 2px 0;
  margin: 0;
}
.voucher {
  width: auto;
  height: 50px;
  margin-right: 10px;
  display: inline-block;

  ::v-deep .el-image__inner {
    width: auto;
    height: 50px;
  }
}
::v-deep .el-dialog__body {
  text-align: center;
}
.class_center {
  width: 100%;
  text-align: center;
}
.trail-content {
  height: 500px;
  display: flex;
  #map_container {
    width: 80%;
    height: 100%;
  }
  .trail-list {
    flex: 1;
    height: 100%;
    overflow: auto;
    .trail-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .trail-container {
      padding:0 10px;
      text-align: left;
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 10px;
      }
    }
  }
}

//解决 baidu-map 1.0 默认样式影响控件
::v-deep .BMap_stdMpPan {
  display: block;
}
::v-deep .BMap_stdMpZoom {
  top: 50px;
}
::v-deep .BMap_scaleCtrl {
  inset: auto auto 30px 100px !important;
}
.waybillbo-style{
  cursor: pointer;
  color: #409EFF;
}
</style>
